var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$userData.age && !!_vm.$gameData.images.titleleaf)?_c('v-layout',{staticClass:"age-intro-wrap",attrs:{"align-center":"","justify-center":""}},[_c('img',{staticClass:"age-intro",attrs:{"src":_vm.template.url}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }